import React from 'react';
import ReactDOM from 'react-dom';
import { LocaleProvider } from 'antd';
import ruRU from 'antd/lib/locale-provider/ru_RU';
import { locale } from 'moment';
import 'moment/locale/ru';

import 'utils/httpCancelPromise';
import 'actions/asyncActions';

import registerServiceWorker from './registerServiceWorker';

import { setBaseUrl, provideResponseInterceptors, provideRequestInterceptors } from 'utils/http';
import { history, Store } from './store';
import 'utils/yupValidation';
import App from 'components/App';

import './styles/index.less';

setBaseUrl();
provideRequestInterceptors();
provideResponseInterceptors();
locale('ru');

if (process.env.NODE_ENV === 'production') {
    const initRollbar = require('./utils/rollbar').default;
    initRollbar(Store);
}

ReactDOM.render(
    (
        <LocaleProvider locale={ruRU}>
            <App store={Store} history={history} />
        </LocaleProvider>
    ),
    document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js